// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-9nuGV";
var _3 = "icon-2dthV";
var _4 = "paper-1Sm2E";
export { _1 as "__esModule", _2 as "button", _3 as "icon", _4 as "paper" }
export default { "__esModule": _1, "button": _2, "icon": _3, "paper": _4 }
